import { Component } from 'react';
import Hls from 'hls.js';

interface Props {
  src: string;
  video?: HTMLVideoElement;
  type?: string;
  /* do not remove. required by video-react */
  isVideoChild?: boolean;
}

class HLSSource extends Component<Props> {
  hls?: Hls;

  private destroyHls = (): void => {
    if (this.hls) {
      this.hls.destroy();
      this.hls = undefined;
    }
  };

  private loadSource = (): void => {
    const { src, video } = this.props;

    if (!video) {
      return;
    }

    this.destroyHls();

    // Safari supports HLS natively. Using its native implementation avoids
    // MediaSource/CORS edge cases and is more reliable than forcing hls.js.
    if (video.canPlayType('application/vnd.apple.mpegurl')) {
      video.src = src;
      video.load();
      return;
    }

    if (Hls.isSupported()) {
      this.hls = new Hls();
      this.hls.loadSource(src);
      this.hls.attachMedia(video);
      return;
    }

    // Keep a native fallback for browsers that can play the source despite
    // not reporting support for MediaSource through hls.js.
    video.src = src;
    video.load();
  };

  componentDidMount() {
    this.loadSource();
  }

  componentDidUpdate(previousProps: Props) {
    if (
      previousProps.src !== this.props.src ||
      previousProps.video !== this.props.video
    ) {
      this.loadSource();
    }
  }

  componentWillUnmount() {
    this.destroyHls();
  }

  render() {
    return (
      <source
        src={this.props.src}
        type={this.props.type || 'application/vnd.apple.mpegurl'}
      />
    );
  }
}

export default HLSSource;
